import { setCookie, getCookie } from '@seller/gilgamesh-web-http-client';

class VersionService {
  get () {
    return getCookie('version');
  }

  set (version) {
    setCookie('version', version);
  }
}

export default new VersionService();
